import { Dialog, IconButton, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { WbCard } from '../../WbCard';
import { useGeneralPurposePickerContext } from '../GeneralPurposePickerContext';
import { GenericEntityType, Provider, TemplateEntity } from '../types';
import { ProviderFilters } from './CommonFilter';
import { MultiSelection } from './MultiSelection/MultiSelection';
import { SingleSelection } from './SingleSelection';
import { useId } from 'react';
import { useResponsiveMobile } from '../../../hooks';

const useStyles = makeStyles(
  {
    dialogCardMobile: {
      boxShadow: 'none',
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
    },
    dialogCard: {
      boxShadow: 'none',
      display: 'flex',
      flexDirection: 'column',
      height: '70vh',
    },
  },
  { name: 'GeneralEntityPickerDialog' },
);
export interface GeneralEntityPickerDialogProps {
  title: string;
  multiSelection?: boolean;
  providerMapper: Map<string, Provider<GenericEntityType[], ProviderFilters>>;
  availableKinds: TemplateEntity[];
  parentTemplateRef?: string;
}

export const GeneralEntityPickerDialog = (
  props: GeneralEntityPickerDialogProps,
) => {
  const { openDialog, setOpenDialog, setAiState, setErrorMessage } =
    useGeneralPurposePickerContext();

  const onDialogClose = () => {
    setOpenDialog(false);
    setAiState(false);
    setErrorMessage(undefined);
  };

  const titleId = useId();
  const isMobile = useResponsiveMobile();

  const classes = useStyles({ isMobile });

  return (
    <Dialog
      open={openDialog}
      onClose={onDialogClose}
      maxWidth="xl"
      fullWidth
      fullScreen={isMobile}
      aria-labelledby={titleId}
    >
      <WbCard
        titleId={titleId}
        title={props.title || 'Select entities'}
        cardClassName={isMobile ? classes.dialogCardMobile : classes.dialogCard}
        actions={
          <IconButton aria-label="close" onClick={onDialogClose} size="small">
            <CloseIcon />
          </IconButton>
        }
      >
        {props.multiSelection ? (
          <MultiSelection
            {...props}
            parentTemplateRef={props.parentTemplateRef}
          />
        ) : (
          <SingleSelection
            {...props}
            parentTemplateRef={props.parentTemplateRef}
          />
        )}
      </WbCard>
    </Dialog>
  );
};
